import { hasAnyPermissions } from "@dashboard/auth/misc";
import { PermissionEnum, UserFragment } from "@dashboard/graphql";
import LabelPrintingSection from "@dashboard/labels";
import { labelPrintingSection } from "@dashboard/labels/urls";
import { ComponentType } from "react";
import { MessageDescriptor } from "react-intl";

import { operatorMessages } from "./messages";

// One entry per operator area. A user sees exactly the modules any of whose
// permissions they hold (from their Saleor permission group); new roles —
// warehouse, sales — are added here with their own permission. The API
// enforces the same permissions on every query/mutation the module uses.
export interface OperatorModule {
  id: string;
  path: string;
  title: MessageDescriptor;
  permissions: PermissionEnum[];
  component: ComponentType;
}

export const OPERATOR_MODULES: OperatorModule[] = [
  {
    id: "labels",
    path: labelPrintingSection,
    title: operatorMessages.labelsModule,
    permissions: [PermissionEnum.PRINT_LABELS, PermissionEnum.MANAGE_PRODUCTS],
    component: LabelPrintingSection,
  },
];

export const operatorModulesFor = (user: UserFragment | null | undefined): OperatorModule[] =>
  user ? OPERATOR_MODULES.filter(module => hasAnyPermissions(module.permissions, user)) : [];
